<template>
	<div class="i-surveys-form-input">
		<form-item v-bind="$attrs">
			<div class="input_control">
				<van-field
					:value="rfrScore"
					placeholder="角色功能-限制（RFR）得分"
					:rules="rules"
					:name="`${itemKey}_rfr`"
					readonly
				>
					<template #left-icon>角色功能-限制（RFR）</template>
					<template #right-icon>分</template>
				</van-field>
			</div>
			<div class="input_control">
				<van-field
					:value="rfpScore"
					placeholder="角色功能-预防（RFP）得分"
					:rules="rules"
					:name="`${itemKey}_rfp`"
					readonly
				>
					<template #left-icon>角色功能-预防（RFP）</template>
					<template #right-icon>分</template>
				</van-field>
			</div>
			<div class="input_control">
				<van-field
					:value="efScore"
					placeholder="情绪功能（EF）得分"
					:rules="rules"
					:name="`${itemKey}_ef`"
					readonly
				>
					<template #left-icon>情绪功能（EF）</template>
					<template #right-icon>分</template>
				</van-field>
			</div>
			<div class="input_control">
				<van-field
					:value="totalScore"
					placeholder="总分（MSQ-Total）"
					:rules="rules"
					:name="`${itemKey}_total`"
					readonly
				>
					<template #left-icon>总分（MSQ-Total）</template>
					<template #right-icon>分</template>
				</van-field>
			</div>
		</form-item>
	</div>
</template>

<script>
import FormItem from "./form-item.vue";

export default {
	components: { FormItem },
	props: {
		value: {
			type: [String, Number],
			default: "",
		},
		placeholder: {
			type: String,
			default: "",
		},
		options: {
			type: Array,
			default: () => [],
		},
		rules: {
			type: Array,
			default: () => [],
		},
		itemKey: {
			type: String,
			default: "",
		},
		needCount: {
			type: [Boolean, Number],
			default: 0,
		},
		exam: {
			type: Array,
			default: () => [],
		},
		startKey: {
			type: String,
			default: "",
		},
		endKey: {
			type: String,
			default: "",
		},
	},
	data: () => ({
		separator: "@%_@%",
	}),
	computed: {
		parsedValues() {
			if (!this.value) {
				return {
					rfrScore: "",
					rfpScore: "",
					efScore: "",
					totalScore: "",
				};
			}
			const [rfrScore, rfpScore, efScore, totalScore] =
				this.value.split("@%_@%");
			return {
				rfrScore: rfrScore || "",
				rfpScore: rfpScore || "",
				efScore: efScore || "",
				totalScore: totalScore || "",
			};
		},
		rfrScore() {
			return this.parsedValues.rfrScore;
		},
		rfpScore() {
			return this.parsedValues.rfpScore;
		},
		efScore() {
			return this.parsedValues.efScore;
		},
		totalScore() {
			return this.parsedValues.totalScore;
		},
		isDisabled() {
			return this.$route.query.formType === "preview";
		},
	},
	methods: {
		calculateMSQScore() {
			if (!this.startKey || !this.endKey) return;

			const startIndex = this.exam.findIndex(
				(item) => item.locationKey === this.startKey
			);
			const endIndex = this.exam.findIndex(
				(item) => item.locationKey === this.endKey
			);

			if (startIndex === -1 || endIndex === -1) return;

			const rfrQuestions = this.exam.slice(startIndex, startIndex + 7);
			const rfpQuestions = this.exam.slice(
				startIndex + 7,
				startIndex + 11
			);
			const efQuestions = this.exam.slice(
				startIndex + 11,
				startIndex + 14
			);

			const rfrRawScore = this.calculateDimensionRawScore(rfrQuestions);
			const rfpRawScore = this.calculateDimensionRawScore(rfpQuestions);
			const efRawScore = this.calculateDimensionRawScore(efQuestions);

			const rfrScore = this.calculateDimensionScore(rfrRawScore, 7);
			const rfpScore = this.calculateDimensionScore(rfpRawScore, 4);
			const efScore = this.calculateDimensionScore(efRawScore, 3);

			const totalRawScore = rfrRawScore + rfpRawScore + efRawScore;
			const totalScore = this.calculateTotalScore(totalRawScore);

			this.$emit(
				"input",
				`${rfrScore}@%_@%${rfpScore}@%_@%${efScore}@%_@%${totalScore}`
			);
		},

		calculateDimensionRawScore(questions) {
			return questions.reduce((sum, question) => {
				if (question.questionType === "11") {
					if (
						question.value !== null &&
						question.value !== undefined &&
						question.value !== ""
					) {
						const option = question.optionList[question.value];
						if (option && option.name) {
							const score = this.getOptionScore(option.name);
							return sum + score;
						}
					}
				}
				return sum;
			}, 0);
		},

		getOptionScore(optionText) {
			const scoreMap = {
				一直: 1,
				总是: 1,
				经常: 2,
				有时: 3,
				偶尔: 4,
				很少: 5,
				从不: 6,
			};
			return scoreMap[optionText] || 0;
		},

		calculateDimensionScore(rawScore, questionCount) {
			const score =
				((rawScore - questionCount) / (questionCount * 5)) * 100;
			return Math.max(
				0,
				Math.min(100, Math.round(score * 100) / 100)
			).toFixed(2);
		},

		calculateTotalScore(rawScore) {
			const score = ((rawScore - 14) / 70) * 100;
			return Math.max(
				0,
				Math.min(100, Math.round(score * 100) / 100)
			).toFixed(2);
		},
	},
	watch: {
		exam: {
			handler(newVal, oldVal) {
				if (newVal && newVal.length > 0) {
					this.calculateMSQScore();
				}
			},
			deep: true,
			immediate: true,
		},
	},
	mounted() {
		this.calculateMSQScore();
	},
};
</script>

<style scoped>
.input_control {
	margin-bottom: 8px;
}

.input_control:last-child {
	margin-bottom: 0;
}
</style>
